<template>
  <SvoiFilePickerComplex v-model="modelValue" v-bind="filteredProps" :type="typeFilePicker" />
</template>

<script lang="ts" setup>
import { SvoiFilePickerComplex } from '@svoi-ui/components/file-picker'
import { TypeEnum as FilePickerTypeEnum } from '@svoi-ui/interfaces/file-picker'

const props = defineProps({
  ...SvoiFilePickerComplex.props,
  type: {
    type: String as PropType<typeof FilePickerTypeEnum[keyof typeof FilePickerTypeEnum]>,
    default: undefined,
  },
})

const modelValue = defineModel<typeof SvoiFilePickerComplex.props.modelValue>()

const { isDesktop } = useBreakpoint()

const typeFilePicker = computed(() => props.type || (isDesktop.value ? FilePickerTypeEnum.dragArea : FilePickerTypeEnum.button))

const filteredProps = computed(() => {
  const { type, ...rest } = props
  return {
    ...rest,
    type: typeFilePicker.value,
  }
})
</script>
